import { apiFetch } from '#imports'
import type { actionResponse } from '~/layers/cms/app/types/cmsTypes'

export const sendMail = async (data: object): Promise<actionResponse> => {
  const options = {
    method: 'POST',
    body: JSON.stringify(data)
  }

  const url = `/api/send-mail`

  return apiFetch(url, options)
}
